import { useMutation } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import axios, { AxiosError } from "axios"
import { getFingerPrint as getFingerprint } from "../../../utils/fingerprint"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../../utils/constants"
import { IRegistrationConfirmResponse } from "./interface"

const API_REGISTRATION_CONFIRM_URL = `${window.extended.REACT_APP_API_URL}/api/registration-2/confirm`

async function registrationConfirmRequest(
  token: string | null,
  code: string,
  fingerprint: string,
  url: string,
) {
  try {
    const response = await axios(API_REGISTRATION_CONFIRM_URL, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: { code, fingerprint, url },
    })
    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
      const { response } = error

      if (response?.data && response.data.error === "otp_attempts_exceeded") {
        return {
          result: "Error",
          token: "",
          errorDetails: {
            code: response.data.error,
            description: response.data.detail,
          },
        }
      }
    }
    throw error
  }
}

export const useRegistrationConfirm = () => {
  const [searchParams] = useSearchParams()
  const exchangeToken = searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)
  const fingerprint = getFingerprint(true)!

  return useMutation<IRegistrationConfirmResponse, void, { code: string }>({
    mutationFn: (req) =>
      registrationConfirmRequest(
        exchangeToken,
        req.code,
        fingerprint,
        "/top-up-mbank-account/registration",
      ),
    retry: false,
  })
}
